interface IDevice {
    id?: string;
    deviceId?: string; 
    groupId?: string; 
    kind?: string; 
    label?: string
}

// from https://stackoverflow.com/questions/30047056/is-it-possible-to-check-if-the-user-has-a-camera-and-microphone-and-if-the-permi

export interface IMediaSupportResult {
    hasMicrophone: boolean;
    hasSpeakers: boolean;
    hasWebcam: boolean;
    isMicrophoneAlreadyCaptured: boolean;
    isWebcamAlreadyCaptured: boolean;
}

module MediaSupport {

    if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
        // Firefox 38+ seems having support of enumerateDevicesx
        (navigator as any).enumerateDevices = function(callback: () => void) {
            navigator.mediaDevices.enumerateDevices().then(callback);
        };
    }
    
    let mediaDeviceList: Array<IDevice> = [];
    const isHTTPs = location.protocol === 'https:';
    let canEnumerate = false;
    
    if (typeof MediaStreamTrack !== 'undefined' && 'getSources' in MediaStreamTrack) {
        canEnumerate = true;
    } else if (navigator.mediaDevices && !!navigator.mediaDevices.enumerateDevices) {
        canEnumerate = true;
    }
    
    const result: IMediaSupportResult = {
        hasMicrophone: false,
        hasSpeakers: false,
        hasWebcam: false,
        isMicrophoneAlreadyCaptured: false,
        isWebcamAlreadyCaptured: false
    };
    
    export function check(callback: (result: IMediaSupportResult) => void) {
        if (!canEnumerate) {
            return;
        }
        const navigatorAny = (navigator as any);
    
        if (!navigatorAny.enumerateDevices && window.MediaStreamTrack && (window.MediaStreamTrack as any).getSources) {
            navigatorAny.enumerateDevices = (window.MediaStreamTrack as any).getSources.bind(window.MediaStreamTrack);
        }
    
        if (!!navigatorAny.enumerateDevices && navigatorAny.enumerateDevices) {
            navigatorAny.enumerateDevices = navigatorAny.enumerateDevices.bind(navigator);
        }
    
        if (!navigatorAny.enumerateDevices) {
            if (callback) {
                callback(result);
            }
            return;
        }
    
        mediaDeviceList = [];
        navigatorAny.enumerateDevices((devices: Array<MediaDeviceInfo>) => {
            devices.forEach(function(mediaDeviceInfo: MediaDeviceInfo) {
                const device: IDevice = { id:void(0), deviceId:void(0), groupId:void(0), kind:void(0), label:void(0) };
                for (const d in mediaDeviceInfo) {
                    (device as any)[d] = (mediaDeviceInfo as any)[d];
                }
                if (device.kind === 'audio') {
                    device.kind = 'audioinput';
                }
                if (device.kind === 'video') {
                    device.kind = 'videoinput';
                }
                let skip = false;
                mediaDeviceList.forEach(d => {
                    if (d.id === device.id && d.kind === device.kind) {
                        skip = true;
                    }
                });
    
                if (skip) {
                    return;
                }
    
                if (!device.deviceId) {
                    device.deviceId = device.id;
                }
    
                if (!device.id) {
                    device.id = device.deviceId;
                }
    
                if (!device.label) {
                    device.label = 'Please invoke getUserMedia once.';
                    if (!isHTTPs) {
                        device.label = `HTTPS is required to get label of this ${device.kind} device.`;
                    }
                } 
                else {
                    if (device.kind === 'videoinput' && !result.isWebcamAlreadyCaptured) {
                        result.isWebcamAlreadyCaptured = true;
                    }
                    if (device.kind === 'audioinput' && !result.isMicrophoneAlreadyCaptured) {
                        result.isMicrophoneAlreadyCaptured = true;
                    }
                }
                if (device.kind === 'audioinput') {
                    result.hasMicrophone = true;
                }
                if (device.kind === 'audiooutput') {
                    result.hasSpeakers = true;
                }
                if (device.kind === 'videoinput') {
                    result.hasWebcam = true;
                }
                // there is no 'videoouput' in the spec.
                mediaDeviceList.push(device);
            });
    
            if (callback) {
                callback(result);
            }
        });
    }
}

export default MediaSupport;